import SelectorEngine from '../../../utils/dom/selector-engine';
import { Events } from '../../../utils/dom/html-events';
import EventHandler from '../../../utils/dom/event-handler';
import Modal from '.../../../components/Modal';

const SELECTOR_WRAPPER = '.p-coach-learning-journey-edit-info';
const SELECTOR_MODAL = '.js-coach-learning-journey-modal';

const SELECTOR_EXIT_BUTTON = '.js-exit-coach-learning-journey';
const SELECTOR_EXIT_CONFIRM_MODAL = '.js-exit-coach-learning-journey-confirm';
const SELECTOR_EXIT_CONFIRM_YES = '.js-exit-coach-learning-journey-confirm-yes';
const SELECTOR_EXIT_CONFIRM_NO = '.js-exit-coach-learning-journey-confirm-no';

class CoachesLearningJourneyEditInfo {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.modalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);
		this.modal = new Modal(this.modalElement, { backdrop: 'static' });
		this.modal.show();

		this.exitButton = SelectorEngine.findOne(SELECTOR_EXIT_BUTTON, this._wrapper);
		const exitConfirmModalHtml = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_MODAL, this._wrapper);
		this.exitConfirmModal = new Modal(exitConfirmModalHtml, { backdrop: 'static' });

		this.exitConfirmYes = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_YES, this._wrapper);
		this.exitConfirmNo = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_NO, this._wrapper);

		this.initEventHandlers();
	}

	initEventHandlers() {
		EventHandler.on(this.exitButton, Events.Click, () => {
			this.exitConfirmModal.show();
		});
		EventHandler.on(this.exitConfirmYes, Events.Click, () => {
			this.handleModalExit();
		});
		EventHandler.on(this.exitConfirmNo, Events.Click, () => {
			this.exitConfirmModal.hide();
		});
	}

	handleModalExit() {
		// Go back to the page that launched the modal
		history.back();
	}
}

const globalCoachesLearningJourneyEditInfo = new CoachesLearningJourneyEditInfo();
export default globalCoachesLearningJourneyEditInfo;
